import { Typography } from '@mui/material';

export default function NotFound() {
  return (
    <Typography variant="h3" noWrap component="div">
      Not Found
    </Typography>
  );
}
